module.exports = __webpack_public_path__ + "img/salon-2009.e304ebb9.jpg";